import type { IContentItem, Elements } from '@kontent-ai/delivery-sdk'

export default function(paddingmodifications: Elements.MultipleChoiceElement){
    if(!paddingmodifications || !paddingmodifications?.value){
        return {
            'pt-0': false,
            'pb-0': false
        }
    }
    return {
        'pt-0': !!paddingmodifications.value.find(x => x.codename == 'no_top_padding'),
        'pb-0': !!paddingmodifications.value.find(x => x.codename == 'no_bottom_padding')
    }

}